import { SET_CURRENT_USER } from '../constants/currentUser';

export const setCurrentUser = (payload) => ({
  type: SET_CURRENT_USER,
  payload,
});